export default __webpack_public_path__ + "static/media/esports-battle-8.7a0b8ccd.png";